export default "__VITE_ASSET__MIiTpKTo__"